// = Libs =
import { FC } from 'react';

// = Styles =
import classes from './footer.module.scss';

// = Components =
import Container from '@/common/containers/container/container';

const Footer: FC = () => {
  return (
    <footer className={classes.footer}>
      <Container>
        <div className={classes.footer__content}>
          <div className={classes.footer__desc}>
            <span>ГИС «Современное образование</span>
            <span>Ленинградской области»</span>
          </div>
          <div className={classes.footer__copyright}>
            <span>© 2021. Оператор электронного правительства</span>
            <span>и Комитет общего и профессионального образования</span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
